import * as Sentry from "@sentry/react";

const BASE64_GROUP_SIZE = 4;
const JWT_PAYLOAD_INDEX = 1;

const base64UrlDecode = (input: string): string => {
  const base64 = input.replace(/-/g, "+").replace(/_/g, "/");
  const remainder = base64.length % BASE64_GROUP_SIZE;
  const padLength = remainder === 0 ? 0 : BASE64_GROUP_SIZE - remainder;
  const padded = base64 + "=".repeat(padLength);
  const binary = atob(padded);
  const bytes = Uint8Array.from(binary, char => char.charCodeAt(0));
  return new TextDecoder("utf-8").decode(bytes);
};

const reportDecodeFailure = (reason: string, error?: unknown): void => {
  Sentry.captureException(error ?? new Error(reason), {
    tags: { module: "features/auth/jwt", function: "decodeJWT" },
    extra: { reason }
  });
};

export const decodeJWT = (token: string): Record<string, unknown> | null => {
  try {
    const payload = token.split(".")[JWT_PAYLOAD_INDEX];
    if (!payload) {
      reportDecodeFailure("JWT is missing its payload segment");
      return null;
    }
    return JSON.parse(base64UrlDecode(payload));
  } catch (error) {
    reportDecodeFailure("Failed to decode JWT payload", error);
    return null;
  }
};
